import { Fragment, useEffect, useState } from "react";
import { cmsAdminApi } from "../../api/cmsApi";

const STATUSES = ["new", "contacted", "in_review", "submitted", "closed"];

function Field({ label, value }) {
  return (
    <div className="mb-2">
      <div className="text-muted small text-uppercase">{label}</div>
      <div>{value || "—"}</div>
    </div>
  );
}

export default function AdminAwsActivatePage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [error, setError] = useState("");
  const [openId, setOpenId] = useState("");

  const refresh = async () => {
    try {
      setItems(await cmsAdminApi.listAwsActivate());
      setError("");
    } catch (e) {
      setError(e.message || "Could not load AWS Activate applications");
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const filtered = filter === "all" ? items : items.filter((i) => i.status === filter);

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>AWS Activate</h1>
          <p>Applications from the AWS Activate form on the website.</p>
        </div>
      </header>
      {error ? <p className="text-danger">{error}</p> : null}

      <div className="admin-panel mb-3">
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <span className="text-muted small text-uppercase fw-bold me-1">Filter</span>
          {["all", ...STATUSES].map((f) => (
            <button
              key={f}
              type="button"
              className={`admin-btn admin-btn-sm${filter === f ? " admin-btn-primary" : " admin-btn-ghost"}`}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? "All" : f.replace("_", " ")}
            </button>
          ))}
        </div>
      </div>

      <div className="admin-panel">
        {filtered.length === 0 ? (
          <p className="admin-empty">No AWS Activate applications yet.</p>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Company / Contact</th>
                  <th>AWS</th>
                  <th>Stage</th>
                  <th>Status</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {filtered.map((item) => {
                  const p = item.payload || {};
                  const isOpen = openId === item.id;
                  return (
                    <Fragment key={item.id}>
                      <tr>
                        <td>
                          <strong>{item.companyName}</strong>
                          <div className="text-muted small">{item.contactName}</div>
                          <div className="text-muted small">{item.contactEmail}</div>
                          <div className="text-muted small">{item.contactPhone || "—"}</div>
                          <div className="text-muted small">{new Date(item.createdAt).toLocaleString()}</div>
                        </td>
                        <td>
                          <div>{item.awsAccountId || "—"}</div>
                          <div className="text-muted small">{p.monthlySpend || "—"}</div>
                        </td>
                        <td>
                          <div>{item.startupStage || "—"}</div>
                          <div className="text-muted small">{item.fundingStatus || "—"}</div>
                        </td>
                        <td>
                          <select
                            className="admin-select-sm"
                            value={item.status}
                            onChange={async (e) => {
                              await cmsAdminApi.updateAwsActivateStatus(item.id, e.target.value);
                              await refresh();
                            }}
                          >
                            {STATUSES.map((s) => (
                              <option key={s} value={s}>
                                {s.replace("_", " ")}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="admin-actions">
                          <button
                            type="button"
                            className="admin-btn admin-btn-sm admin-btn-ghost"
                            onClick={() => setOpenId(isOpen ? "" : item.id)}
                          >
                            {isOpen ? "Hide" : "Details"}
                          </button>
                          <button
                            type="button"
                            className="admin-btn admin-btn-sm admin-btn-danger"
                            onClick={async () => {
                              if (!window.confirm("Delete this AWS Activate application?")) return;
                              await cmsAdminApi.deleteAwsActivate(item.id);
                              await refresh();
                            }}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                      {isOpen ? (
                        <tr>
                          <td colSpan={5}>
                            <div className="row g-3 p-2">
                              <div className="col-md-4">
                                <Field label="Founder" value={p.founderName} />
                                <Field label="Registered name" value={p.registeredName} />
                                <Field label="Location" value={[p.city, p.state, p.country].filter(Boolean).join(", ")} />
                                <Field label="Website" value={p.website} />
                                <Field label="LinkedIn" value={p.linkedin} />
                              </div>
                              <div className="col-md-4">
                                <Field label="Industry" value={p.industry} />
                                <Field label="Team size" value={p.teamSize} />
                                <Field label="Year established" value={p.yearEstablished} />
                                <Field label="Job title" value={p.jobTitle} />
                                <Field label="Contact method" value={p.contactMethod} />
                              </div>
                              <div className="col-md-4">
                                <Field label="AWS account email" value={p.awsAccountEmail} />
                                <Field label="AWS root email" value={p.awsRootEmail} />
                                <Field label="Org ID" value={p.awsOrgId} />
                                <Field label="Investor" value={p.investorName} />
                                <Field
                                  label="Documents"
                                  value={(item.documentNames || []).join(", ") || "None"}
                                />
                              </div>
                              <div className="col-12">
                                <Field label="Message" value={p.message} />
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : null}
                    </Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
